import Common from '../../../Common';

interface Search {
	limit?: number,
	limit_from?: number,
	search?: string,
	order_by?: string,
	order_dir?: string,
	show?: string,
	datetime_from?: string,
	datetime_to?: string,
}

const defaultSearch = {
	limit: 25,
	limit_from: 0,
}

const History = class extends Common {
	browse = (userId: id, search: Search = defaultSearch) =>
		this.get(`/user/${userId}/call/history`, search);

	download = (userId: id, search: Search = defaultSearch): CustomResponse<Blob> =>
		this.get(`/user/${userId}/call/history/download`, search, { responseType: 'blob' });

	delete = () =>
		this.doDelete(`/user/call/history`)
}

export default History
